import { ThemeStyle } from '../interfaces/theme';

// THEMEVALUES: Constante que guarda la configuración de cada tema
export const THEMEVALUES: { [undeterminedIndex: string]: ThemeStyle } = {
    balanced: {
        textColorOverBackgroundBody: '#000000',
        textColorOverBackground: '#ffffff',
        backgroundForSections: '#ffffff',
        background: '#558b2f',
        scale: [95, 10],
        type: 'light',
    },
    repotencia: {
        textColorOverBackgroundBody: '#000000',
        textColorOverBackground: '#ffffff',
        backgroundForSections: '#ffffff',
        background: '#002669',
        scale: [100, 10],
        type: 'light',
    },
    risk: {
        textColorOverBackgroundBody: '#ffffff',
        textColorOverBackground: '#ffffff',
        backgroundForSections: '#373738',
        background: '#eb8005',
        scale: [35, -10],
        type: 'dark',
    },
    light: {
        textColorOverBackgroundBody: '#212121',
        textColorOverBackground: '#ffffff',
        backgroundForSections: '#ffffff',
        background: '#00acc1',
        scale: [90, 0],
        type: 'light',
    },
    dark: {
        textColorOverBackgroundBody: '#ffffff',
        textColorOverBackground: '#ffffff',
        backgroundForSections: '#373738',
        background: '#4527a0',
        scale: [60, 0],
        type: 'dark',
    },
    fire: {
        textColorOverBackgroundBody: '#000000',
        textColorOverBackground: '#ffffff',
        backgroundForSections: '#ffffff',
        background: '#6e0200',
        scale: [75, 10],
        type: 'light',
    }
};
